import L from 'leaflet';
import { useFleetStore } from '@/stores/fleet';

export class PortsLayer {
    constructor(map, layerControl) {
        this.map = map;
        this.layerControl = layerControl;
        this.overlays = null;
    }

    addPortsLayer() {
        const fleetStore = useFleetStore();

        if (!this.map) return;
        try {
            
            let portsData = fleetStore.data.ports || [];

            // Создание группы кластеров для портов
            this.overlays = L.markerClusterGroup({
                disableClusteringAtZoom: 14,
                spiderfyOnMaxZoom: false,
                chunkedLoading: true,
                maxClusterRadius: 80,
                showCoverageOnHover: false,
                iconCreateFunction: (cluster) => {
                    return L.divIcon({
                        html: `<div class="cluster-icon" title="⚓ Ports: ${cluster.getChildCount()}">${cluster.getChildCount()}</div>`,
                        className: 'port-cluster',
                        iconSize: L.point(40, 40)
                    });
                }
            });

            // Пакетная обработка маркеров для ускорения
            const markers = portsData
                .filter(entry => entry.name && !isNaN(entry.lat) && !isNaN(entry.lon))
                .map(entry => {
                    return L.circleMarker([entry.lat, entry.lon], {
                        pane: 'markers',
                        radius: 7,
                        color: 'green',
                        fillColor: 'green',
                        fillOpacity: 0.6
                    }).bindTooltip("⚓ " + entry.name, {
                        direction: 'top',
                        permanent: false,
                        className: 'ports-tooltip',
                        opacity: 0.9
                    });
                });

                portsData = null;

                // Добавление маркеров в кластер
                this.overlays.addLayers(markers);

                if (this.layerControl) {
                    this.layerControl.addOverlay(this.overlays, 'Ports');
                }
        } catch (error) {
            console.error('Failed to load ports data:', error);
        }
    }

    // Очистка и удаление слоя портов
    destroy() {

        if (this.overlays) {
            if (this.layerControl) {
                this.layerControl.removeLayer(this.overlays);
            }
            if (this.map && this.map.hasLayer(this.overlays)) {
                this.map.removeLayer(this.overlays);
            }
            this.overlays.clearLayers();
            this.overlays = null;
        }

        // if (this.overlays.ports && this.map.hasLayer(this.overlays.ports)) {

        this.map = null;
        this.layerControl = null;
    }

}